<template>
    <div class="formfield">
        <img :src="icon" class="textfield-icon">
        <v-text-field
            v-model="theValue"
            :label="placeholder"
            required
            @input ='(v) => v'
            class="textfield-content"
            :type="type ==='password'? 'password':'text'"
            :mask="mask"
        ></v-text-field>
    </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String
    },
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    mask: {
      type: String
    }
  },
  data: function() {
    return {
      theValue: this.value
    };
  },
  watch: {
    theValue() {
      this.$emit("input", this.theValue);
    }
  }
};
</script>

<style>
.formfield {
  position: relative;
  height: 8vh;
}
.textfield-icon {
    position: absolute;
    left: 0;
    top: 15px;
}

.textfield-content {
  padding-left: 0.125rem;
}
.textfield-content:focus-within {
  margin-top: 10px;
}
/* .v-text-field {
  margin: 0 !important;
} */
.v-text-field .v-input__control .v-input__slot {
    padding-left: 1.8rem;
}
.formfield input {
  padding-bottom: 0 !important;
}
</style>
